import React from "react";
import { Paper, Typography, Stack, Box, LinearProgress } from "@mui/material";

const rows = [
  { name: "Produtora Alpha", value: 480, delta: "+12%" },
  { name: "Eventos Sul", value: 360, delta: "+8%" },
  { name: "OnFire", value: 310, delta: "+5%" },
  { name: "Grupo BH", value: 240, delta: "-2%" },
  { name: "Label Norte", value: 190, delta: "+3%" },
];

export default function OrganizersRankingCard() {
  const max = Math.max(...rows.map((r) => r.value));

  return (
    <Paper
      sx={{
        p: { xs: 2.2, md: 2.6 },
        borderRadius: 1,
        height: "100%",
        minHeight: { xs: 260, md: 320 },
      }}
    >
      <Typography fontWeight={950} mb={1.2}>
        Ranking de organizadores
      </Typography>

      <Typography fontSize={12} color="text.secondary" mb={2}>
        Receita estimada por organizador (período atual).
      </Typography>

      <Stack spacing={1.6}>
        {rows.map((r, i) => {
          const pct = (r.value / max) * 100;
          const isNeg = r.delta.startsWith("-");
          return (
            <Box key={i}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="baseline"
              >
                <Typography fontWeight={850}>{r.name}</Typography>

                <Stack direction="row" spacing={1} alignItems="baseline">
                  <Typography
                    fontSize={12}
                    color={isNeg ? "error.main" : "success.main"}
                    fontWeight={900}
                  >
                    {r.delta}
                  </Typography>
                  <Typography color="text.secondary" fontSize={12}>
                    R$ {r.value}k
                  </Typography>
                </Stack>
              </Stack>

              <Box sx={{ borderRadius: 1, overflow: "hidden", mt: 0.6 }}>
                <LinearProgress
                  variant="determinate"
                  value={pct}
                  sx={{ height: 10, borderRadius: 0 }}
                />
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Paper>
  );
}
